enum MainInvoiceAgreementObjectId {
  EINVOICE = 'EINVOICE',
  DIGIPOST = 'DIGIPOST',
}

export default MainInvoiceAgreementObjectId;
